import Splitting from "splitting";

Splitting({
  target: "[data-splitting]",
  by: "chars",
  key: null,
  whitespace: true,
});

function handleAnimation(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const chars = entry.target.querySelectorAll(".char");
      chars.forEach((char, index) => {
        setTimeout(() => {
          char.classList.add("animate");
        }, index);
      });
      observer.unobserve(entry.target); // Stop observing once animation starts
    }
  });
}

// Trigger animation when scrolled into view
const curvedText = document.querySelectorAll(".curved-text");
const observer = new IntersectionObserver(handleAnimation, {
  threshold: 0.5,
});

curvedText.forEach((text) => {
  observer.observe(text);
});
